import {debounce, executeOnElementResize} from '../helpers'

export default async function () {
    window.addEventListener('resize', debounce(__loadFloatingIcons, 500))

    executeOnElementResize(document.body, __loadFloatingIcons)

    return Promise.all([__loadAlpineJS(), __loadFloatingIcons()])
}

async function __loadAlpineJS() {
    // Load all Alpine.js scripts
    let [Alpine, intersect, collapse, morph, focus, persist] = (
        await Promise.all([
            import('alpinejs'),
            import('@alpinejs/intersect'),
            import('@alpinejs/collapse'),
            import('@alpinejs/morph'),
            import('@alpinejs/focus'),
            import('@alpinejs/persist'),
        ])
    ).map((m) => m.default)

    const [directives, properties, store, bindings, components] = (
        await Promise.all([
            import('../alpine-plugins/directives'),
            import('../alpine-plugins/properties'),
            import('../alpine-plugins/store'),
            import('../alpine-plugins/bindings'),
            import('../alpine-plugins/components'),
        ])
    ).map((m) => m.default)

    Alpine.plugin(intersect)
    Alpine.plugin(collapse)
    Alpine.plugin(morph)
    Alpine.plugin(focus)
    Alpine.plugin(persist)

    directives(Alpine)
    properties(Alpine)
    store(Alpine)
    bindings(Alpine)

    for (const component in components) {
        Alpine.data(component, components[component])
    }

    // Load alpine and make it globally available for debugging and extending
    window.Alpine = Alpine
    Alpine.start()
}

async function __loadFloatingIcons() {
    /**
     * @var {HTMLTemplateElement[]} items
     */
    const items = Array.from(document.querySelectorAll('template.background-accent-item'))
    const wrapper = document.querySelector('.floaters-wrapper')
    const partial = new DocumentFragment()

    wrapper.innerHTML = ''

    let documentHeight = getAvailableDocumentHeight()

    // Check how many times the document fits into the viewport
    let times = Math.ceil(documentHeight / window.innerHeight) || 1

    // If there are more items than times available, only show the first times items
    if (items.length > times) {
        items.length = times
    }

    const spaceBetween = documentHeight / items.length

    items.forEach((item, key) => {
        // get icon from item template
        const clone = item.cloneNode(true)
        const icon = clone.content.firstElementChild

        icon.classList.add('hidden', 'md:block', 'absolute', (key + 1) % 2 ? 'left-0' : 'right-0', '-z-1')
        icon.setAttribute('width', '128')
        icon.setAttribute('height', '128')
        icon.setAttribute('style', `top: ${spaceBetween * (key + 1)}px`)
        partial.appendChild(icon)
    })

    wrapper.appendChild(partial)
}

function getAvailableDocumentHeight() {
    let documentHeight = document.body.scrollHeight
    // Reduce main footer height
    documentHeight -= document.querySelector('#main-footer').offsetHeight
    // Reduce sub footer height
    documentHeight -= document.querySelector('#sub-footer').offsetHeight
    // Reduce header height
    documentHeight -= document.querySelector('#header').offsetHeight

    return documentHeight
}
